module.exports = __webpack_public_path__ + "static/testimonial-doka-rik-239e95562c661533c8d7d4d8f4b488e2.jpg";